/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { Http, Response } from '@angular/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { JSONSearchParams } from '../core/search.params';
import { ErrorHandler } from '../core/error.service';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Rx';
import { MarketplaceAccess } from '../../models/MarketplaceAccess';
import { SocketConnection } from '../../sockets/socket.connections';


/**
 * Api services for the `MarketplaceAccess` model.
 */
@Injectable()
export class MarketplaceAccessApi extends BaseLoopBackApi {

  constructor(
    @Inject(Http) protected http: Http,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Inject(JSONSearchParams) protected searchParams: JSONSearchParams,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http,  connection,  models, auth, searchParams, errorHandler);
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} company_code 
   *
   * @param {string} user 
   *
   * @param {String} access_token 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `MarketplaceAccess` object.)
   * </em>
   */
  public getDataSalaryEmployee(company_code: any, user: any, access_token: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/MarketplaceAccesses/getDataSalaryEmployee/:company_code/:user";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof company_code !== 'undefined' && company_code !== null) _urlParams.company_code = company_code;
    if (typeof user !== 'undefined' && user !== null) _urlParams.user = user;
    if (typeof access_token !== 'undefined' && access_token !== null) _urlParams.access_token = access_token;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `MarketplaceAccess`.
   */
  public getModelName() {
    return "MarketplaceAccess";
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/services/custom/MarketplaceAccess.ts